__turbopack_context__.v({
  "close-button": "Modal-module-scss-module__We2o2a__close-button",
  "contentShow": "Modal-module-scss-module__We2o2a__contentShow",
  "dialog-children": "Modal-module-scss-module__We2o2a__dialog-children",
  "dialog-content": "Modal-module-scss-module__We2o2a__dialog-content",
  "dialog-content-full-width": "Modal-module-scss-module__We2o2a__dialog-content-full-width",
  "dialog-overlay": "Modal-module-scss-module__We2o2a__dialog-overlay",
  "dialog-title": "Modal-module-scss-module__We2o2a__dialog-title",
  "overlayShow": "Modal-module-scss-module__We2o2a__overlayShow",
});
